<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './voucherBaseEdit';

  export default {
    name: 'editVoucher',
    components: {
      baseEdit,
    },
    mounted() {},
  };
</script>
